module.exports = __webpack_public_path__ + "static/media/prototype_development.92d5fc48.svg";